import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import {
  CvSectionDate,
  CvSectionDateResponse,
  UpdateCvSectionDateRequest,
} from '@/../gen';

export const namespace = 'cvSectionDateEdit';
const actionCreator = actionCreatorFactory(namespace);
export const GetCvSectionDate = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
}>('GET_CV_SECTION_DATE');
export const SetCvSectionDate = actionCreator<CvSectionDateResponse>(
  'SET_CV_SECTION_DATE'
);
export const UpdateCvSectionDate = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
  body: UpdateCvSectionDateRequest;
}>('UPDATE_CV_SECTION_DATE');
export const DeleteCvSectionDate = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
}>('DELETE_CV_SECTION_DATE');
export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cvSectionDate: CvSectionDate;
}

const initialState = (): State => {
  return { cvSectionDate: null };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(GetCvSectionDate, async function(context, action) {
      const { data } = await this.proffApi.getCvSectionDate(
        action.payload.params.cv_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionDate(data.data));
    }),
    action(UpdateCvSectionDate, async function(context, action) {
      const { data } = await this.proffApi.updateCvSectionDate(
        action.payload.params.cv_id,
        action.payload.params.id,
        action.payload.body
      );
      context.commit(SetCvSectionDate(data.data));
    }),
    action(DeleteCvSectionDate, async function(context, action) {
      await this.proffApi.deleteCvSectionDate(
        action.payload.params.cv_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionDate(null));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetCvSectionDate, (state, action) => {
      state.cvSectionDate = action.payload?.attributes;
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cvSectionDate: state => state.cvSectionDate,
  },
};
